import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiEndpoints } from '../constants/api-endpoints';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class FlatRenterMappingService {
  constructor(private readonly api: ApiService) {}

  list(payload: any = {}): Observable<any> {
    return this.api.postHandler(ApiEndpoints.FLAT_RENTER_MAPPING_LIST, payload);
  }

  create(payload: any = {}): Observable<any> {
    return this.api.postHandler(ApiEndpoints.FLAT_RENTER_MAPPING_CREATE, payload);
  }

  update(payload: any = {}): Observable<any> {
    return this.api.postHandler(ApiEndpoints.FLAT_RENTER_MAPPING_UPDATE, payload);
  }

  delete(payload: any = {}): Observable<any> {
    return this.api.postHandler(ApiEndpoints.FLAT_RENTER_MAPPING_DELETE, payload);
  }

  paymentPendingList(payload: any = {}): Observable<any> {
    return this.api.postHandler(ApiEndpoints.PAYMENT_PENDING_LIST, payload);
  }
}
